import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities/apiFetch";
import { logger } from "common/utilities/logger";
import { deleteCollectionFailure, deleteCollectionSuccess, fetchCollections } from "domains/collection/actions";
import type { DeleteCollectionAction } from "domains/collection/actionTypes";
import { CollectionType } from "domains/collection/types/collectionType";

export function* deleteCollectionSaga({ payload }: DeleteCollectionAction) {
  try {
    yield apiFetch(`collection/${payload.id}`, { method: "DELETE" });
    yield put(deleteCollectionSuccess(payload.id));
    yield put(fetchCollections(CollectionType.Editable));
  } catch (error) {
    logger.error(`[deleteCollectionSaga] Failed to delete collection with ID '${payload.id}'`, error);
    yield put(deleteCollectionFailure());
  }
}
